import React, { useEffect, useState } from "react";
import "./index.scoped.css";
import {
  getCasinoBetsAPI,
  getCasinoExposureAPI,
  getCasinoLastTenResultAPI,
  getCasinoOddsAPI,
} from "../../service/casino";
import { useQuery } from "react-query";
import CasinoVideo from "./components/CasinoVideo";
import Timer from "./components/Timer";
import {
  CARD_ARRAY,
  cardArray,
  CASINO_VIDEO,
  getCasinoPlExposureByRunner,
  getOddForEntity,
  setBet,
} from "./CasinoGeneric";
import PlaceBet from "./components/PlaceBet";
import { useDispatch } from "react-redux";
import PlacedBet from "./components/PlacedBet";
import CasinoPage from "./components/CasinoPage";
import { useLocation } from "react-router-dom";
export default function Baccarat29() {
  const location = useLocation();
  var GAME_ID = location.pathname.split("/");
  GAME_ID = GAME_ID[GAME_ID.length - 1];
  // const GAME_ID = "AAA";
  const VIDEO_ID = "teensin";
  // const VIDEO_ID = CASINO_VIDEO.amarAkbarAnthony;
  const dispatch = useDispatch();
  const [casinoPlData, setCasinoPlData] = useState([]);

  const casinoData = useQuery(
    "getCasinoOdds",
    () => getCasinoOddsAPI(GAME_ID),
    {
      refetchInterval: 800,
    }
  );

  const getPlExposure = async () => {
    const { response } = await getCasinoExposureAPI(
      casinoData?.data?.response?.marketId
    );
    setCasinoPlData(response);
  };
  useEffect(() => {
    if (casinoData?.data?.response?.marketId) {
      let interval = setInterval(() => {
        getPlExposure();
      }, 2000);
      return () => {
        clearInterval(interval);
      };
    }
  }, [casinoData?.data?.response?.marketId]);

  return (
    <CasinoPage
      casino={casinoData?.data}
      VIDEO_ID={VIDEO_ID}
      // VIDEO_ID={GAME_ID}
      GAME_ID={GAME_ID}
      // VIDEO_ID={CASINO_VIDEO.thirtyTwoCardB}
      //  VIDEO_ID={GAME_ID}
      // GAME_ID={GAME_ID}
      // shortName={"cards32a cards32b"}
       gameName={"29Card Baccarat"}
    >
      {/* <div className="center-main-container casino-page"> */}
      {/* <div className="center-container"> */}
      {/* <div className="casino-page-container baccarat29"> */}
      {/* <div className="casino-header"> */}
      {/* <span className="casino-name">
              29Card Baccarat
              <a className="ms-1">
                <small>Rules</small>
              </a>
            </span> */}
      {/* <span className="casino-rid d-none d-xl-inline-block">
              <small>
                Round ID: <span>137250426202413</span>
              </small>
            </span> */}
      {/* </div> */}
      {/* <div className="casino-title-header-mobile d-xl-none"> */}
      {/* <ul className="nav nav-tabs menu-tabs">
              <li className="nav-item">
                <div className="nav-link active">Game</div>
              </li>
              <li className="nav-item">
                <div className="nav-link">Placed Bet (0)</div>
              </li>
            </ul> */}
      {/* <div className="pe-2">
              <span className="casino-rid">
                Round ID: <span>137250426202413</span>
              </span>
            </div> */}
      {/* </div> */}
      {/* <div className=""> */}
      {/* <div className="casino-video"> */}
      {/* <div className="video-box-container"> */}
      {/* <div className="casino-video-box"> */}
      {/* <iframe src="/mediaplayer/teensin/f760ca50-8ad4-4cbf-a0ad-80c8ccaa0ce0?ip=122.160.119.41" /> */}
      {/* </div> */}
      {/* </div> */}
      {/* <div className="casino-video-cards">
                <div className="">
                  <h5>Player A</h5>
                  <div className="flip-card-container">
                    <div className="flip-card">
                      <div className="flip-card-inner ">
                        <div className="flip-card-front">
                          <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/1.jpg" />
                        </div>
                        <div className="flip-card-back">
                          <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/1.jpg" />
                        </div>
                      </div>
                    </div>
                    <div className="flip-card">
                      <div className="flip-card-inner ">
                        <div className="flip-card-front">
                          <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/1.jpg" />
                        </div>
                        <div className="flip-card-back">
                          <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/1.jpg" />
                        </div>
                      </div>
                    </div>
                    <div className="flip-card">
                      <div className="flip-card-inner ">
                        <div className="flip-card-front">
                          <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/1.jpg" />
                        </div>
                        <div className="flip-card-back">
                          <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/1.jpg" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="mt-1">
                  <h5>Player B</h5>
                  <div className="flip-card-container">
                    <div className="flip-card">
                      <div className="flip-card-inner ">
                        <div className="flip-card-front">
                          <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/1.jpg" />
                        </div>
                        <div className="flip-card-back">
                          <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/1.jpg" />
                        </div>
                      </div>
                    </div>
                    <div className="flip-card">
                      <div className="flip-card-inner ">
                        <div className="flip-card-front">
                          <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/1.jpg" />
                        </div>
                        <div className="flip-card-back">
                          <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/1.jpg" />
                        </div>
                      </div>
                    </div>
                    <div className="flip-card">
                      <div className="flip-card-inner ">
                        <div className="flip-card-front">
                          <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/1.jpg" />
                        </div>
                        <div className="flip-card-back">
                          <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/1.jpg" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div> */}
      {/* <div className="clock flip-clock-wrapper">
              <ul className="flip play">
                <li className="flip-clock-before">
                  <a href="#">
                    <div className="up">
                      <div className="shadow" />
                      <div className="inn">0</div>
                    </div>
                    <div className="down">
                      <div className="shadow" />
                      <div className="inn">0</div>
                    </div>
                  </a>
                </li>
                <li className="flip-clock-active">
                  <a href="#">
                    <div className="up">
                      <div className="shadow" />
                      <div className="inn">3</div>
                    </div>
                    <div className="down">
                      <div className="shadow" />
                      <div className="inn">3</div>
                    </div>
                  </a>
                </li>
              </ul>
              <ul className="flip play">
                <li className="flip-clock-before">
                  <a href="#">
                    <div className="up">
                      <div className="shadow" />
                      <div className="inn">4</div>
                    </div>
                    <div className="down">
                      <div className="shadow" />
                      <div className="inn">4</div>
                    </div>
                  </a>
                </li>
                <li className="flip-clock-active">
                  <a href="#">
                    <div className="up">
                      <div className="shadow" />
                      <div className="inn">3</div>
                    </div>
                    <div className="down">
                      <div className="shadow" />
                      <div className="inn">3</div>
                    </div>
                  </a>
                </li>
              </ul>
            </div> */}
      {/* </div> */}
      <div className="casino-detail">
        <div className="casino-table">
          <div className="casino-table-box">
            <div className="casino-table-left-box">
              <div className="casino-table-header">
                <div className="casino-nation-detail">Player A</div>
              </div>
              <div className="casino-table-body">
                <div className="casino-table-row">
                  <div className="casino-odds-box">
                    Winner
                    <p className="casino-nation-book d-none d-md-block w-100">
                      {getCasinoPlExposureByRunner(casinoPlData, "Player A")}
                    </p>
                  </div>
                  <div className="casino-odds-box">
                    High Card
                    <p className="casino-nation-book d-none d-md-block w-100">
                      {getCasinoPlExposureByRunner(casinoPlData, "High Card A")}
                    </p>
                  </div>
                  <div className="casino-odds-box">
                    Pair
                    <p className="casino-nation-book d-none d-md-block w-100">
                      {getCasinoPlExposureByRunner(casinoPlData, "Pair A")}
                    </p>
                  </div>
                  <div className="casino-odds-box">
                    Color Plus
                    <p className="casino-nation-book d-none d-md-block w-100">
                      {getCasinoPlExposureByRunner(
                        casinoPlData,
                        "Color Plus A"
                      )}
                    </p>
                  </div>
                </div>
                <div className="casino-table-row">
                  {/* <div className="casino-odds-box back"> */}
                  <div
                    className={`casino-odds-box back  ${
                      casinoData?.data?.response?.autoTime < 5
                        ? "suspended-box"
                        : ""
                    }`}
                    onClick={() =>
                      setBet("Player A", casinoData, dispatch, "back")
                    }
                  >
                    <span className="casino-odds">
                      {" "}
                      {getOddForEntity("Player A", casinoData, true)}
                    </span>
                    <span className="casino-nation-book" />
                  </div>
                  {/* <div className="casino-odds-box back"> */}
                  <div
                    className={`casino-odds-box back  ${
                      casinoData?.data?.response?.autoTime < 5
                        ? "suspended-box"
                        : ""
                    }`}
                    onClick={() =>
                      setBet("High Card A", casinoData, dispatch, "back")
                    }
                  >
                    <span className="casino-odds">
                      {" "}
                      {getOddForEntity("High Card A", casinoData, true)}
                    </span>
                    <span className="casino-nation-book" />
                  </div>
                  {/* <div className="casino-odds-box back"> */}
                  <div
                    className={`casino-odds-box back  ${
                      casinoData?.data?.response?.autoTime < 5
                        ? "suspended-box"
                        : ""
                    }`}
                    onClick={() =>
                      setBet("Pair A", casinoData, dispatch, "back")
                    }
                  >
                    <span className="casino-odds">
                      {getOddForEntity("Pair A", casinoData, true)}
                    </span>
                    <span className="casino-nation-book" />
                  </div>
                  {/* <div className="casino-odds-box back"> */}
                  <div
                    className={`casino-odds-box back  ${
                      casinoData?.data?.response?.autoTime < 5
                        ? "suspended-box"
                        : ""
                    }`}
                    onClick={() =>
                      setBet("Color Plus A", casinoData, dispatch, "back")
                    }
                  >
                    <span className="casino-odds">
                      {getOddForEntity("Color Plus A", casinoData, true)}
                    </span>
                    <span className="casino-nation-book" />
                  </div>
                </div>
              </div>
            </div>
            <div className="casino-table-box-divider" />
            <div className="casino-table-right-box">
              <div className="casino-table-header">
                <div className="casino-nation-detail">Player B</div>
              </div>
              <div className="casino-table-body">
                <div className="casino-table-row">
                  <div className="casino-odds-box">
                    Winner
                    <p className="casino-nation-book d-none d-md-block w-100">
                      {getCasinoPlExposureByRunner(casinoPlData, "Player B")}
                    </p>
                  </div>
                  <div className="casino-odds-box">
                    High Card
                    <p className="casino-nation-book d-none d-md-block w-100">
                      {getCasinoPlExposureByRunner(casinoPlData, "High Card B")}
                    </p>
                  </div>
                  <div className="casino-odds-box">
                    Pair
                    <p className="casino-nation-book d-none d-md-block w-100">
                      {getCasinoPlExposureByRunner(casinoPlData, "Pair B")}
                    </p>
                  </div>
                  <div className="casino-odds-box">
                    Color Plus
                    <p className="casino-nation-book d-none d-md-block w-100">
                      {getCasinoPlExposureByRunner(
                        casinoPlData,
                        "Color Plus B"
                      )}
                    </p>
                  </div>
                </div>
                <div className="casino-table-row">
                  {/* <div className="casino-odds-box back"> */}
                  <div
                    className={`casino-odds-box back  ${
                      casinoData?.data?.response?.autoTime < 5
                        ? "suspended-box"
                        : ""
                    }`}
                    onClick={() =>
                      setBet("Player B", casinoData, dispatch, "back")
                    }
                  >
                    <span className="casino-odds">
                      {" "}
                      {getOddForEntity("Player B", casinoData, true)}
                    </span>
                    <span className="casino-nation-book" />
                  </div>
                  {/* <div className="casino-odds-box back"> */}
                  <div
                    className={`casino-odds-box back  ${
                      casinoData?.data?.response?.autoTime < 5
                        ? "suspended-box"
                        : ""
                    }`}
                    onClick={() =>
                      setBet("High Card B", casinoData, dispatch, "back")
                    }
                  >
                    <span className="casino-odds">
                      {" "}
                      {getOddForEntity("High Card B", casinoData, true)}
                    </span>
                    <span className="casino-nation-book" />
                  </div>
                  {/* <div className="casino-odds-box back"> */}
                  <div
                    className={`casino-odds-box back  ${
                      casinoData?.data?.response?.autoTime < 5
                        ? "suspended-box"
                        : ""
                    }`}
                    onClick={() =>
                      setBet("Pair B", casinoData, dispatch, "back")
                    }
                  >
                    <span className="casino-odds">
                      {getOddForEntity("Pair B", casinoData, true)}
                    </span>
                    <span className="casino-nation-book" />
                  </div>
                  {/* <div className="casino-odds-box back"> */}
                  <div
                    className={`casino-odds-box back  ${
                      casinoData?.data?.response?.autoTime < 5
                        ? "suspended-box"
                        : ""
                    }`}
                    onClick={() =>
                      setBet("Color Plus B", casinoData, dispatch, "back")
                    }
                  >
                    <span className="casino-odds">
                      {getOddForEntity("Color Plus B", casinoData, true)}
                    </span>
                    <span className="casino-nation-book" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="casino-table-full-box mt-3">
            <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/lucky9.png" />

            <div className="casino-odd-box-container">
              {/* <div className="casino-odds-box back"> */}
              <div
                className={`casino-odds-box back  ${
                  casinoData?.data?.response?.autoTime < 5
                    ? "suspended-box"
                    : ""
                }`}
                onClick={() => setBet("Lucky 9", casinoData, dispatch, "back")}
              >
                <span className="casino-odds">
                  {" "}
                  {getOddForEntity("Lucky 9", casinoData, true)}
                </span>
              </div>
              {/* <div className="casino-odds-box lay"> */}
              <div
                className={`casino-odds-box lay  ${
                  casinoData?.data?.response?.autoTime < 5
                    ? "suspended-box"
                    : ""
                }`}
                onClick={() => setBet("Lucky 9", casinoData, dispatch, "lay")}
              >
                <span className="casino-odds">
                  {" "}
                  {getOddForEntity("Lucky 9", casinoData, false)}
                </span>
              </div>
              {/* <div className="casino-nation-book text-center w-100" /> */}
              <p className="casino-nation-book d-none d-md-block w-100">
                {getCasinoPlExposureByRunner(casinoPlData, "Lucky 9")}
              </p>
            </div>
          </div>
        </div>
        {/* <div className="casino-last-result-title">
          <span>Last Result</span>
          <span>
            <a href="/casino-results/teensin">View All</a>
          </span>
        </div> */}
        {/* <div className="casino-last-results">
          <span className="result result-a">A</span>
          <span className="result result-b">B</span>
          <span className="result result-a">A</span>
          <span className="result result-b">B</span>
          <span className="result result-b">B</span>
          <span className="result result-b">B</span>
          <span className="result result-a">A</span>
          <span className="result result-a">A</span>
          <span className="result result-b">B</span>
          <span className="result result-b">B</span>
        </div> */}
        <div className="sidebar-box my-bet-container mt-2 d-xl-none">
          <div className="sidebar-title">
            <h4>Rules</h4>
          </div>
          <div className="">
            <div className="table-responsive">
              <table className="table table-bordered">
                <thead>
                  <tr>
                    <th colSpan={2} className="text-center">
                      Color Plus Rules
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Straight</td>
                    <td>1 TO 2</td>
                  </tr>
                  <tr>
                    <td>Flush</td>
                    <td>1 TO 5</td>
                  </tr>
                  <tr>
                    <td>Trio</td>
                    <td>1 TO 20</td>
                  </tr>
                  <tr>
                    <td>Straight Flush</td>
                    <td>1 TO 30</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      {/* </div> */}
      <div className="d-none">
        <div className="table-responsive">
          <table className="table">
            <thead>
              <tr>
                <th>Matched Bet</th>
                <th className="text-end">Odds</th>
                <th className="text-end">Stake</th>
              </tr>
            </thead>
            <tbody />
          </table>
        </div>
      </div>
      {/* </div> */}
      {/* </div> */}
      {/* <div className="sidebar right-sidebar casino-right-sidebar">
        <div className="sidebar-box my-bet-container">
          <div className="sidebar-title">
            <h4>My Bet</h4>
          </div>
          <div className="my-bets">
            <div className="table-responsive">
              <table className="table">
                <thead>
                  <tr>
                    <th>Matched Bet</th>
                    <th className="text-end">Odds</th>
                    <th className="text-end">Stake</th>
                  </tr>
                </thead>
                <tbody />
              </table>
            </div>
          </div>
        </div>
        <div className="sidebar-box my-bet-container">
          <div className="sidebar-title">
            <h4>Rules</h4>
          </div>
          <div className="">
            <div className="table-responsive">
              <table className="table table-bordered">
                <thead>
                  <tr>
                    <th colSpan={2} className="text-center">
                      Color Plus Rules
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Straight</td>
                    <td>1 TO 2</td>
                  </tr>
                  <tr>
                    <td>Flush</td>
                    <td>1 TO 5</td>
                  </tr>
                  <tr>
                    <td>Trio</td>
                    <td>1 TO 20</td>
                  </tr>
                  <tr>
                    <td>Straight Flush</td>
                    <td>1 TO 30</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div> */}
      {/* </div> */}
    </CasinoPage>
  );
}
